module.exports = __webpack_public_path__ + "static/media/ellipsis-vertical.0f0a0de0.svg";